<template>
    <div>
       
        <div class="tile is-ancestor object-preview-card">
            <div class="tile is-8 is-centered has-limited-width-600">
                <article class="tile is-child is-12">
                    <div @click.stop>
                        <header class="modal-card-head is-block mt-3" :class="backgroundClass">
                            <div class="level is-mobile">
                                <div class="level-left">
                                    <div class="level-item">
                                        <p class="object-type is-size-5">{{objectType}}</p>
                                    </div>
                                </div>
                                <div class="level-right">
                                    <div class="level-item">
                                        <img
                                            src="@/assets/images/logo_eduloc360.png"
                                            alt="eduloc360"
                                            width="160"
                                        />
                                    </div>
                                </div>
                            </div>
                        </header>
                        
                        <section class="modal-card-body">
                            
                            <div class="level is-mobile" v-if="isMultilang">
                                <div class="level-left">
                                    <div class="level-item" v-if="content.title">
                                        <p class="
                                                title
                                                is-size-4
                                                has-text-weight-normal	
                                            " :title="getName(content)">
                                            {{ getName(content) }}
                                        </p>
                                    </div>
                                    
                                </div>
                                <div class="level-right">
                                    <div class="level-right">
                                        <div class="navbar-item has-dropdown is-hoverable" v-if="isMultilang">
                                            <a class="navbar-link is-arrowless mr-4" style="text-transform: capitalize;">
                                                <!--<span class="icon"><i class="mdi mdi-28px mdi-web"></i></span>-->
                                                {{ langLabel(activeLang) }}
                                            </a>

                                            <div class="navbar-dropdown">
                                                <a
                                                    v-for="lang in languages"
                                                    :key="lang"
                                                    @click="activeLang = lang"
                                                    class="navbar-item"
                                                    style="text-transform: capitalize;"
                                                >
                                                    {{ langLabel(lang) }}
                                                </a>
                                            
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <p v-if="content.title"
                                    class="
                                        title
                                        is-size-5
                                        has-text-weight-normal
                                        mb-0
                                    "
                                > {{ content.title }}
                                </p>
                            </div>
                            <!--
                               -->

                            <ObjectGallery
                                id="images-gallery"
                                v-if="content.images && content.images.length"
                                :images="content.images"
                                :showing="true"
                            />
                            <!--<ObjectVideo
                                v-if="content.video"
                                :video="content.video"
                                class="pt-3"
                            />-->
                            
                            <div v-if="isMultilang">
                                <div v-for="langCode in $store.getters.project.langs" :key="langCode" class="lang-field" :class="{'is-active':activeLang==langCode}">
                                    <p
                                        class="content has-text-black mb-0"
                                        v-html="getDescription"
                                    />
                                </div>
                            </div>
                            <div v-else>
                                <p
                                    class="content has-text-black mb-0"
                                    v-html="content.description"
                                />
                            </div>

                            <div v-if="isMultilang">
                                <div  v-if="hasVideo">
                                    <div v-for="langCode in $store.getters.project.langs" :key="langCode" class="lang-field" :class="{'is-active':activeLang==langCode}">
                                        <ObjectVideo :video="getVideo(langCode)" class="pt-3" />
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <ObjectVideo v-if="content.video" :video="content.video" class="pt-3" />
                            </div>

                            <div v-if="isMultilang">
                                <div class="audio-player mb-4" v-if="hasAudio">
                                    <div v-for="langCode in $store.getters.project.langs" :key="langCode" class="lang-field" :class="{'is-active':activeLang==langCode}">
                                        <ObjectAudio :audio="getAudio(langCode)" />
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="audio-player mb-4" v-if="content.audio">
                                    <ObjectAudio :audio="content.audio" />
                                </div>
                            </div>

                            <!--<ObjectAudio
                                v-if="content.audio"
                                :audio="content.audio"
                            />-->
                            <object-card-tags
                                v-if="content.tags"
                                :tags="content.tags"
                            />
                            
                            
                            
                            <ObjectEmbed
                                v-if="content.embed"
                                :embed="content.embed"
                            />
                            <ObjectStaticMap
                                v-if="!locationIsEmpty && !isMap"
                                :location="content.location"
                                :tileProvider="tileProvider"
                                class="map-preview"
                            />

                            <!--<ObjectURL
                                v-if="content.url"
                                :url="content.url"
                            />-->
                            <div v-if="isMultilang">
                                <div class="links-zone mb-4 px-0 py-0" v-if="hasUrl">
                                    <div v-for="langCode in $store.getters.project.langs" :key="langCode" class="lang-field" :class="{'is-active':activeLang==langCode}">
                                        <ObjectURL  :url="getUrl(langCode)" class="" />
                                    </div>
                                </div>
                            </div>
                            <div v-else class="links-zone mb-4 px-0 py-0">
                                <ObjectURL v-if="content.url" :url="content.url" class="" />
                            </div>

                            <div v-if="isMultilang">
                                <div v-for="langCode in $store.getters.project.langs" :key="langCode" class="lang-field" :class="{'is-active':activeLang==langCode}">
                                    <ObjectFiles
                                        :files="getFiles(langCode)"
                                    />
                                </div>
                            </div>
                            <div v-else>
                                <ObjectFiles
                                    v-if="
                                        content.files &&
                                        content.files.length
                                    "
                                    :files="content.files"
                                />
                            </div>

                            <div v-if="isMultilang">
                                <div v-if="content.answersPerLang">
                                    <div v-for="langCode in $store.getters.project.langs" :key="langCode" class="lang-field" :class="{'is-active':activeLang==langCode}">
                                        <TreasurehuntPreviewObjectQuestion
                                            :answers="getAnswers(langCode)"
                                            :answerType="content.questionType"
                                        />
                                    </div>
                                </div>

                            </div>
                            <div v-else>
                                <div v-if="content.answers">
                                    <TreasurehuntPreviewObjectQuestion
                                        :answers="content.answers"
                                        :answerType="content.questionType"
                                    />
                                </div>
                            </div>
                            
                        </section>
                        
                    </div>
                </article>
            </div>
        </div>

    </div>
</template>

<script>
import { likeObject } from '@/services/API';
import { isEmpty } from 'underscore';
import AppModalView from '@/components/AppModalView';
import ProjectModalShare from '@/components/ProjectModalShare';
import ObjectGallery from '@/components/ObjectGallery';
import ObjectVideo from '@/components/ObjectVideo';
import ObjectAudio from '@/components/ObjectAudio';
import ObjectEmbed from '@/components/ObjectEmbed';
import ObjectStaticMap from '@/components/ObjectStaticMap';
import ObjectFiles from '@/components/ObjectFiles';
import ObjectURL from '@/components/ObjectURL';
import ObjectCardTags from '@/components/ObjectCardTags';
import TreasurehuntPreviewObjectQuestion from '@/components/TreasurehuntPreviewObjectQuestion';
import _ from 'underscore';
export default {
    components: {
        AppModalView,
        ProjectModalShare,
        ObjectGallery,
        ObjectVideo,
        ObjectAudio,
        ObjectEmbed,
        ObjectStaticMap,
        ObjectFiles,
        ObjectURL,
        ObjectCardTags,
        TreasurehuntPreviewObjectQuestion,
    },
    props: {
        object: { type: Object, default: {} },
        location: {type: String, default: ''},
        tileProvider: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data: function () {
        return { showShareModal: false, showAllComments: false, activeLang: '' };
    },
    computed: {
        content() {
            return this.object;
        },
        contentURL() {
            return window.location.href;
        },
        isMap() {
            return 'map' === this.$store.getters.project.mode;
        },
        locationIsEmpty() {
            return isEmpty(this.content.location);
        },
        objectType(){
            switch(this.object.type){
                case 'object':
                    return this.$t('App.object');
                case 'question':
                    return this.$t('App.question');
                case 'clue':
                    return this.$t('App.clue');
            }
        },
        backgroundClass(){
            switch(this.object.type){
                case 'object':
                    return "has-background-eduloc-blue"
                case 'question':
                    return "has-background-eduloc-orange";
                case 'clue':
                    return "has-background-eduloc-red";
            }
        },
        languages() {
            return this.$store.getters.project.langs;
        },
        isMultilang() {
            return this.$store.getters.project.langs && this.$store.getters.project.langs.length > 0;  
        },
        defaultLang() {
            return this.$store.getters.project.defaultLang;
        },
        hasAudio() {
            if (this.isMultilang && (this.content.audioPerLang && !_.isEmpty(this.content.audioPerLang))) {
                return true;
            }
            return false;
        },
        hasVideo() {
            if (this.isMultilang && (this.content.videoPerLang && !_.isEmpty(this.content.videoPerLang))) {
                
                return true;
            }
            return false;
        },
        hasUrl() {
            if (this.isMultilang && (this.content.urlPerLang && !_.isEmpty(this.content.urlPerLang))) {
                return true;
            }
            return false;
        },
        hasFiles() {
            if (this.isMultilang && this.content.filesPerLang && !_.isEmpty(this.content.filesPerLang)) {
                return true;
            }
            return false;
        },
        getDescription() {
            if (this.isMultilang) {
                let locale = this.$i18n.locale;
                if (locale == 'ca-ES') {
                    locale = "ca";
                }
                const defaultLang = this.$store.getters.project.defaultLang;
                // console.log("desc locale", locale)
                if (this.content.descriptionPerLang && this.content.descriptionPerLang[this.activeLang]) {
                    return this.content.descriptionPerLang[this.activeLang];
                }  else if (defaultLang && this.content.descriptionPerLang && this.content.descriptionPerLang[defaultLang]) {
                    // console.log("desc returning default")
                    return this.content.descriptionPerLang[defaultLang]
                } else if (this.content.descriptionPerLang && this.content.descriptionPerLang[locale]) {
                    // console.log("desc returning locale")
                    return this.content.descriptionPerLang[locale]
                }
                // console.log("no desc")
            } else {
                return this.content.description;
            }
        }
        
    },
    mounted: function () {
        // console.log("in mounted treasurehunt object preview",this.location)
        if (this.isMultilang) {
            // console.log("setting activeLang")
            let locale = this.$i18n.locale;
            if (locale == 'ca-ES') {
                locale = "ca";
            }
            // console.log(locale,this.$store.getters.project.langs.includes(locale))
            if (this.$store.getters.project.langs.includes(locale)) {
                this.activeLang = locale;
            } else {
                this.activeLang = this.$store.getters.project.defaultLang;
            }
            // console.log("setting activeLang setted to",this.activeLang)
        }
    },
    methods: {
        langLabel(lang) {
            return this.$t("LANG_" + lang);
        },
        getName(item) {
            if (this.isMultilang) {
                let locale = this.$i18n.locale;
                if (locale == 'ca-ES') {
                    locale = "ca";
                }
                const defaultLang = this.$store.getters.project.defaultLang;
                // console.log("locale", locale)
                if (item.titlePerLang && item.titlePerLang[this.activeLang]) {
                    return item.titlePerLang[this.activeLang];
                }  else if (defaultLang && item.titlePerLang && item.titlePerLang[defaultLang]) {
                    // console.log("returning default")
                    return item.titlePerLang[defaultLang]
                } else if (item.titlePerLang && item.titlePerLang[locale]) {
                    // console.log("returning locale")
                    return item.titlePerLang[locale]
                }else {
                    // console.log("returning standar")
                    return item.title;
                }
                
            } else {
                return item.title;
            }
            
        },
        /*getDescription(item) {
            if (this.isMultilang) {
                let locale = this.$i18n.locale;
                if (locale == 'ca-ES') {
                    locale = "ca";
                }
                const defaultLang = this.$store.getters.project.defaultLang;
                // console.log("locale", locale)
                if (item.descriptionPerLang && item.descriptionPerLang[this.activeLang]) {
                    return item.descriptionPerLang[this.activeLang];
                }  else if (defaultLang && item.descriptionPerLang && item.titlePerLang[defaultLang]) {
                    // console.log("returning default")
                    return item.descriptionPerLang[defaultLang]
                } else if (item.descriptionPerLang && item.titlePerLang[locale]) {
                    // console.log("returning locale")
                    return item.descriptionPerLang[locale]
                }else {
                    // console.log("returning standar")
                    return item.dscription;
                }
                
            } else {
                return item.title;
            }
            
        },*/
        getAudio(lang) {
            if (this.content.audioPerLang && this.content.audioPerLang[lang]) {
                // console.log("audio correct lang")
                return this.content.audioPerLang[lang];
            } else if (this.content.audioPerLang && this.content.audioPerLang[this.defaultLang]) {
                // console.log("audio defaultLang")
                return this.content.audioPerLang[this.defaultLang]
            }
        },
        getVideo(lang) {
            if (this.content.videoPerLang && this.content.videoPerLang[lang]) {
                // console.log("video correct lang")
                return this.content.videoPerLang[lang];
            } else if (this.content.videoPerLang && this.content.videoPerLang[this.defaultLang]) {
                // console.log("video defaultLang")
                return this.content.videoPerLang[this.defaultLang]
            }
        },
        getUrl(lang) {
            if (this.content.urlPerLang && this.content.urlPerLang[lang]) {
                // console.log("video correct lang")
                // console.log(this.content.urlPerLang[lang])
                return this.content.urlPerLang[lang];
            } else if (this.content.urlPerLang && this.content.urlPerLang[this.defaultLang]) {
                // console.log("video defaultLang")
                // console.log(this.content.urlPerLang[this.defaultLang])
                return this.content.urlPerLang[this.defaultLang]
            }
        },
        getFiles(lang) {
            if (this.content.filesPerLang && this.content.filesPerLang[lang]) {
                // console.log("video correct lang")
                return this.content.filesPerLang[lang];
            } else if (this.content.filesPerLang && this.content.filesPerLang[this.defaultLang]) {
                // console.log("video defaultLang")
                return this.content.filesPerLang[this.defaultLang]
            }
        },
        getAnswers(lang) {
            if (this.content.answersPerLang && this.content.answersPerLang[lang]) { 
                return this.content.answersPerLang[lang];
            } else {
                return this.content.answersPerLang[this.defaultLang]
            }
        }
    },
};
</script>

<style scoped>
.modal-card-title {
    flex-shrink: 1;
}
/*.object-preview-card{
    max-height: calc(100vh - 160px);
}*/

.modal-card-body{
    max-height: calc(100vh - 120px);
}
.modal-card-body > * + * {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.modal-content {
    width: 100%;
    padding: 20px;
    overflow: auto;
}
.lb-modal-comments {
    max-height: 90vh;
}
.lb-card-comments {
    margin: auto;
}
.is-long-title {
    flex-grow: 1;
    width: 0;
}
.is-centered {
    margin: 0 auto;
}
.has-limited-width-600 {
    max-width: 600px;
}
.object-type{
    opacity: 0.6;
    color: white;
}
.modal-card-head{
    padding-top: 10px;
    padding-bottom: 10px;
}

.lang-field{
    display: none;
}
.lang-field.is-active{
    display: block;
}
</style>
